module.exports = __webpack_public_path__ + "static/media/Ding-sound-effect.fce0c803.mp3";